export default __webpack_public_path__ + "static/media/Employment_Information.92c73c7a.pdf";